export const isLocalDev = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';
export const BASE_URL = window.location.origin;
export const isTesting = process.env['TESTING'] === 'true';

/**
 * Check if app is running in production environment.
 * REACT_APP_IS_INTERNAL_ENV is an opt-in option. It needs to be set to 'true' for non-prod environment.
 * This is to prevent accidental missing values in the environment variables.
 * */
export const isProduction =
  window.location.hostname.startsWith('levvr') || process.env.REACT_APP_IS_INTERNAL_ENV !== 'true';
